<template>
    <v-main class="ml-6 mt-3">
        <v-row dense class="mt-2 ml-1">
            <h3>Review overview per accommodation/host/caretaker</h3>
        </v-row>
        <v-row class="my-8">
            <div style="width: 18vw" class="ml-4">
                <select_huislist :isClearable="true" field="huis_code" label="Accommodation" @updateData="updateData"/>
            </div>
            <div style="width: 36vw" class="ml-4">
                <select_eignlist :isClearable="true" :isMultiple="true" field="eign_code" label="Host" @updateData="updateData"/>
            </div>
            <div style="width: 13vw" class="ml-4">
                <select_role :isClearable="true" label="Role" field="role" @updateData="updateData"/>
            </div>
            <div style="width: 8vw" class="ml-4">
                <select_ares_language :isClearable="false" label="Language" field="language" @updateData="updateData"/>
            </div>
        </v-row>
        <v-row dense class="mt-3 ml-1">
            <btn_create_excel :report_program="report" :report_request="report_request" :report_params="report_params"
                :show_progress="true" @hasError="showError"/>
        </v-row>
        <navBar title="Ares - Customer Success" :home="true" type="customersuccess" goto="/task/customer_success/mnCustomerSuccess" />
        <standard_dialog ref="std_dialog" />    
    </v-main>
</template>
  
<script>
import navBar from "@/components/ui/navbars/navbar.vue";
import btn_create_excel from "@/components/ui/buttons/btn_create_excel.vue";
import select_role from "@/components/ui/selectors/select_roles.vue";
import select_eignlist from "@/components/ui/selectors/select_eign.vue";
import select_huislist from "@/components/ui/selectors/select_huis.vue";
import select_ares_language from "@/components/ui/selectors/select_ares_language.vue";
import standard_dialog from '@/components/ui/standard_dialog.vue';

export default {
    components: {
        navBar,
        btn_create_excel,
        select_role,
        select_eignlist,
        select_huislist,
        standard_dialog,
        select_ares_language
    },
    data() {
        return {
            report: "ares/json/ares/task/customer_success/eign/ovrz1.p",
            report_params: {
                role: '',
                eign_code: [],
                huis_code: '',
                language: 'EN'
            },
            report_request: "ovrz1",
        }
    },
    methods:{
        updateData(data){
            this.report_params[data.field]=data.value;
        },
        showError(error){
            this.$refs.std_dialog.open('error', "Error", error.message);    
        }
    }
}

</script> 

<style scoped>

</style>
  
  
  
  
  